import { Directive, ElementRef, Input, OnChanges, SimpleChanges } from '@angular/core';
import { AbstractControl, NG_VALIDATORS, ValidationErrors, Validator } from '@angular/forms';
import { PhoneNumberUtil } from 'google-libphonenumber';

@Directive({
    selector: '[appPhoneValidator]',
    providers: [
        {
            provide: NG_VALIDATORS,
            useExisting: PhoneValidatorDirective,
            multi: true
        }
    ]
})
export class PhoneValidatorDirective implements Validator {
    @Input('appPhoneValidator') countryCode: string = 'IN';
    
    private phoneUtil = PhoneNumberUtil.getInstance();

    validate(control: AbstractControl): ValidationErrors | null {
        const value = control.value;

        if (!value) {
            return null; // don’t validate empty (let "required" handle that)
        }

        try {
            const number = this.phoneUtil.parseAndKeepRawInput(value, this.countryCode);
            const isValid = this.phoneUtil.isValidNumberForRegion(number, this.countryCode);

            return isValid ? null : { invalidPhone: true };
        } catch (e) {
            return { invalidPhone: true };
        }
    }
}